export default {
      path: '/social-challenge-result',
      component: () => import('./SocialChallengeResult'),
      meta: {
        title: '心动挑战',
        expireIn: 'Sun Jan 09 2099 20:19:14 GMT+0800 (China Standard Time)',
        designWidth: 750
      }
    }
